<template>
  <div class="consultation-service">
    <div class="title">咨询服务：</div>
    <p>
      为便用户了解德邦快递的各项快递服务、产品和优惠信息，用户自愿同意接受德邦快递通过短信、电话等方式免费向用户发送相关快递服务、产品资讯、优惠服务以及客户体验调查。
      用户同意接受本项服务后，仍可通过德邦快递客服热线 <span class="sign">95353</span> 、信息推送渠道指定方式或手机APP进行退订，不再接收上述资讯。
      用户如对本服务存在疑问、投诉或建议，可拨打德邦快递电话95353、或登录官方网站 （<a href="https://www.deppon.com">www.deppon.com</a> ）、或通过手机APP、或通过德邦快递小程序咨询或反映。受理用户的问题后，我们将在15个工作日内给予答复。
    </p>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.consultation-service{
    display: block;
    width: 100%;
    max-width: 1200px;
    padding: 0 20px;
    margin: 58px auto;
    text-align: left;
    line-height: 24px;
    .title {
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 16px;
    }
    .sign {
      font-weight: 600;
      color: #000;
    }
    a {
      color: #008CFF ;
    }



}
</style>